import React from 'react';

import { FlexContainer } from 'styles/common';

import theme from 'constants/theme';

import { Typography12 } from 'uiToolkit/Typography';

export const ProgressGridElement = ({ headingText, children, style }) => (
  <FlexContainer style={{ flexDirection: 'column', ...style }}>
    <Typography12 weight={600} gutterBottom={1} customColor={theme.palette.text.label}>
      {headingText}
    </Typography12>
    <div
      style={{
        height: '2.5rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  </FlexContainer>
);
